import { gsap, ScrollTrigger } from '../globals/gsap';

import Anchors from './anchors';
import Toplink from './toplink';

class Sticky {
  constructor($el) {
    this.$el = $el;
    this.$nav = this.$el.find('[data-sticky="nav"]');
    this.$anchors = this.$el.find('[data-sticky="anchors"]');
    this.$toplink = this.$el.find('[data-sticky="toplink"]');
    this.$content = this.$el.find('[data-sticky="content"]');
    this.init();
  }

  init = () => {
    // pin this.$el to top of screen
    this.pinNav();

    // init anchors
    this.initAnchors();

    // init toplink
    this.initToplink();
  }

  pinNav = () => {

    // pin this.$nav to top of screen
    gsap.to(this.$nav, {
      scrollTrigger: {
        trigger: this.$nav,
        start: 'top top',
        endTrigger: this.$el,
        end: `bottom ${this.$nav.outerHeight()}px`,
        pin: true,
        pinSpacing: false,
        markers: false,
      },
    });
  }

  initAnchors = () => {
    if(this.$anchors.length) {
      this.anchors = new Anchors(this.$anchors, this.$content); 
    }
  }

  initToplink = () => {
    if(this.$toplink.length) {
      new Toplink(this.$toplink);
    }
  }

  destroy = () => {
    this.anchors.destroy();
  }
}

export default Sticky;